import { ContentType } from "@redotech/redo-model/conversation";

//TODO: refactor to render messages based on their message type not the conversation platform
export const getContentTypeSummary = (contentType?: ContentType): string => {
  if (!contentType) {
    return "(empty message)";
  }
  switch (contentType) {
    case ContentType.PRODUCT_DISPLAY:
      return "The AI showed product recommendations";
    case ContentType.CART_ITEMS:
      return "The AI displayed shopping cart items";
    case ContentType.DISPLAY_ORDER_TRACKING_INFO:
      return "The AI showed order tracking details";
    case ContentType.TRACK_ORDER_UI:
      return "The AI provided order tracking options";
    case ContentType.TOOL_CALL_PRODUCT_INFO:
      return "The AI shared product details";
    case ContentType.TOOL_CALL_RELEVANT_PRODUCTS:
      return "The AI suggested related products";
    case ContentType.SUBSCRIBE_TO_BACK_IN_STOCK_NOTIFICATION:
      return "The AI set up a restock notification";
    case ContentType.SUBSCRIBE_TO_BACK_IN_STOCK_NOTIFICATION_UI:
      return "The AI offered restock alerts";
    case ContentType.CONTACT_SUPPORT_UI:
      return "The AI provided support contact options";
    case ContentType.EMAIL_INPUT:
      return "The AI requested an email address";
    case ContentType.DISCOUNT_CODE:
      return "The AI applied a discount code";
    case ContentType.RESEND_RETURN_LABEL_UI:
      return "The AI offered return label options";
    case ContentType.TOOL_CALL_TRACK_ORDER_AVAILABLE:
      return "The AI checked if the order can be tracked";
    case ContentType.TOOL_CALL_ERROR:
      return "The AI encountered an issue";
    case ContentType.UPDATE_ADDRESS:
      return "The AI requested an address update";
    case ContentType.TOOL_CONFIRMATION_PROMPT:
      return "The AI asked for confirmation";
    case ContentType.UPDATE_ORDER:
      return "The AI update the order";
    case ContentType.CANCEL_ORDER:
      return "The AI processed an order cancellation";
    case ContentType.PRODUCT_VISUALIZATION_UPLOAD_UI:
      return "The AI requested a photo for product visualization";
    case ContentType.PRODUCT_VISUALIZATION_RESULT:
      return "The AI generated a product visualization";
    case ContentType.TOOL_CALL:
      return "The AI performed an action";
    case ContentType.TEXT:
      return "(empty message)";
    default:
      return "(empty message)";
  }
};
